export default __webpack_public_path__ + "static/media/birthday-game-pic.cf1f6724.jpg";